import SectionHeading from '@/components/feature/SectionHeading';
import { characters } from '@/mocks/drama';

const toneMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-800',
};

const lineMap: Record<string, string> = {
  primary: 'bg-primary-500',
  accent: 'bg-accent-500',
  secondary: 'bg-secondary-500',
};

export default function Characters() {
  return (
    <section id="characters" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          eyebrow="Character map"
          title="人物关系与立场梳理"
          desc="故事里的每个人都在用自己的方式回避或靠近真相。理清他们的身份与动机，才能看懂冲突为什么一步步升级。"
        />

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {characters.map((person) => (
            <article
              key={person.name}
              className="relative overflow-hidden rounded-lg border border-background-200 bg-background-100 p-5 md:p-6"
            >
              <span className={`absolute left-0 top-0 h-full w-1 ${lineMap[person.tone]}`} />
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-lg font-semibold text-foreground-950">
                  {person.name}
                </h3>
                <span className={`rounded-full px-3 py-1 text-xs font-label ${toneMap[person.tone]}`}>
                  {person.role}
                </span>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{person.desc}</p>
              <div className="mt-4 flex items-start gap-2 border-t border-background-200 pt-4">
                <i className="ri-links-line mt-0.5 text-base text-primary-500"></i>
                <p className="text-xs md:text-sm leading-relaxed text-foreground-700">
                  {person.relation}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}